import { createSlice } from "@reduxjs/toolkit";

const notificationSlice = createSlice({
  name: "notification",
  initialState: {
    permission: null,
  },
  reducers: {
    setNotificationPermission: (state, action) => {
      state.permission = action.payload;
    },
  },
});

export const { setNotificationPermission } = notificationSlice.actions;
// export const notificationPermission = (state) => state.notification.permission;
export default notificationSlice.reducer;
